import { Stack, Typography } from '@mui/material';

export const Copyright = () => (
  <Stack>
    <Typography
      variant="caption"
      textAlign="center"
      sx={{
        mt: 6,
      }}
    >
      Copyright © {new Date().getFullYear()} HuhiFC. All rights reserved.
    </Typography>
  </Stack>
);
